
import { useLocation, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {turretVoteGetVoterInfo,turretStoreGetDepositLink} from "../apiConn.js"
import { getStripeProductCount } from '../graphql/queries';
import { Amplify, API, graphqlOperation } from 'aws-amplify';
import {ProductImageArea} from "./ProductImageArea.js"

export function PurchasePage(props) {



	const [voterInfo, setVoterInfo] = useState(null);
	const [twitchAccessToken, setTwitchAccessToken] = useState(null);
	const [emailProvided, setEmailProvided] = useState(false);
	const [paymentURLPrototype, setPaymentURLPrototype] = useState(null);
	const [didClickVerify, setDidClickVerify] = useState(false);
	const [productCount, setProductCount] = useState(0)
	const [soldOut, setSoldOut] = useState(false)
	const [buyMessage, setBuyMessage] = useState(null)
	const [productPrice, setProductPrice] = useState("49.99")
	const [totalProducts, setTotalProducts] = useState("50")
	const [shipsString, setShipsString] = useState("Ships to US only within 2 weeks of purchase")

	

	const location = useLocation();
	  const locPath = location.hash.split("#").pop()
	  const params = locPath.split("&")
	  const paramDict = {}

	params.forEach(param => {
	    var p = param.split("=")
	    paramDict[p[0]] = p[1]
	  })


	console.log("location",location)

	var voteLinkPrefix = props.url + "vote?streamer="

	useEffect(() => {

    

	    if (paramDict.access_token) {
	      setTwitchAccessToken(paramDict.access_token)
	    } else {
	      // console.log("set token",window.localStorage.getItem('twitchAccessToken'))
	      setTwitchAccessToken(window.localStorage.getItem('twitchAccessToken'));
	    }
	    fetchProductCount()
	    
	  }, []);



	useEffect(() => {
	    console.log("accesstoken",twitchAccessToken)
	    console.log("accesstoken",didClickVerify)
	    if (!twitchAccessToken) {

	      return
	    }

	    window.localStorage.setItem('twitchAccessToken', twitchAccessToken);

	    console.log("paymentURLPrototype",paymentURLPrototype)

	      if (!paymentURLPrototype) {
	      	turretStoreGetDepositLink(twitchAccessToken,"treatBotPrototype")
			    .then(res => {
			      console.log('treatBotPrototype',res)

			      if (res.authorized) {
			      	setPaymentURLPrototype(res.paymentURL)
			      	setSoldOut(res.soldOut)
			      } else {
			      	setBuyMessage(res.message)
			      	setDidClickVerify(false)
			      }
			      
			      
			    })

	      }


	  }, [twitchAccessToken]);


	function validateEmail(email) 
	{
	 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
	  {
	    return (true)
	  }
	    // alert("You have entered an invalid email address!")
	    return (false)
	}


	function onVerify() {
    setDidClickVerify(true)
  }


  function fetchProductCount() {
      var roverQuery = { query: getStripeProductCount, variables: {id: "prod_OqfY65G2CgaaMD"} }
      roverQuery["authMode"] = 'AWS_IAM'
      return API.graphql(roverQuery)
      .then(res => {
        const data = res.data.getStripeProductCount
        
        console.log("counts",data)

        const productCount = Math.max(data.productCount,0)

        setProductCount(productCount)
		setTotalProducts(data.totalProducts)
		setProductPrice(data.productPrice)
		setShipsString(data.shipsString)

        if (productCount == 0) {
        	setSoldOut(true)
        }
      })

  }

  function logOut() {
    window.localStorage.setItem("twitchAccessToken","")
    window.open(props.url + "store","_self")
  }


	return (
		<div className="col-12 min-vh-100">


		<div className="row justify-content-left">

		<div className="col-12 col-sm-8 col-md-6">
			<ProductImageArea />
			</div>

      <div className="col-12 col-md-6 px-5 py-5">


        <div className="row mb-5">
          <div className="col-8">

          	<div className="row mb-3">
              <h3 className="store-title text-start">Treat Bot</h3>
            </div>

            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">${productPrice}</p>
                </div>
              </div>
              
            </div>

            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">{productCount}</p>
                </div>
              </div>
              <div className="col-auto ps-1">
                <div className="row">
                  <p className="store-subtitle text-start">/{totalProducts} available</p>
                </div>
              </div>
              
            </div>

            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">Features</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
              	<ul>
              		<li className="store-subtitle text-start">Followers use bits to dispense treats</li>
              		<li className="store-subtitle text-start">Holds human or pet treats</li>
              		<li className="store-subtitle text-start">Works with the Treat Bot Extension</li>
              	</ul>
                  
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">{shipsString}</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle text-start">Each prototype is made to order, so the shipping date will vary based on where you are in line.</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">Be a Treat Bot OG</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle text-start">Be one of the first streamers to ever use a Twitch connected treat dispenser. By getting one of our prototypes you will help test and shape our product and will always be a Treat Bot OG.</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle-bold text-start">This is A Beta Version</p>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-auto pe-0">
                <div className="row">
                  <p className="store-subtitle text-start">While we worked out most of the bugs, we cannot gurantee things won't break, but we will be there to fix them at no cost to you.</p>
                </div>
              </div>
            </div>

		        {  ((!twitchAccessToken || buyMessage)&& !didClickVerify) &&
			        <div className="row justify-content-left mb-4">
			              <div className="col-12">
			                <div className="row">
			                  <button className="btn btn-purple" onClick={onVerify} >
			                      Verify Twitch Account to Purchase
			                  </button>
			                  </div>
			              </div>
			            </div>

			      }


			    {!soldOut && twitchAccessToken && !buyMessage &&
		        <div className="row justify-content-left px-3">
		          <a href={paymentURLPrototype} target="_blank">
		          	<div className ="row">
		          		<button className="btn btn-purple" disabled={!paymentURLPrototype}>
	                    Buy
	                  </button>
		          	</div>
		          	
		          </a>
		        </div>
		      }




		      {soldOut &&
		        <div className="row justify-content-left px-3">
		          <button className="btn btn-purple" disabled>
			                    Sold Out
			                  </button>
		        </div>
		      }


		      {(didClickVerify && (!twitchAccessToken || buyMessage)) && <VerifyButton url={props.url + "store"}/>}

		      {twitchAccessToken && 
			      <div className="row my-2 px-3">
			      		<button className="btn btn-light-gray" onClick={logOut}>log out</button>
			      </div>
		      
		    	}

		      {buyMessage && <p className="my-1" style={{color:"red"}}>{buyMessage}</p>}
          	
          </div>
		      

        </div>

        

      </div>
    </div>

		

		



      	</div>
	)

}

export function VerifyButton(props) {

	

	var redirectURL = props.url

  var twitchURL = "https://id.twitch.tv/oauth2/authorize?response_type=token&client_id=i48k75a6j36dxliez6ryyxpfzzg4a0&redirect_uri=" + redirectURL + "&state=c3ab8aa609ea11e793ae92361f002671&force_verify=true"
  var twitchURLWithEmail = "https://id.twitch.tv/oauth2/authorize?response_type=token&client_id=i48k75a6j36dxliez6ryyxpfzzg4a0&redirect_uri=" + redirectURL + "&state=c3ab8aa609ea11e793ae92361f002671&force_verify=true&scope=user%3Aread%3Aemail"




	return (

      		<div>
		      

		      <div className="row justify-content-left mb-4">
		              <div className="col-6">
		                <a href={twitchURLWithEmail} style={{"text-decoration" : "none"}}>
		                <div className="row">
		                  <button className="btn btn-purple" >
		                      Verify & Provide Email
		                  </button>
		                  </div>
		                </a>
		              </div>




		              <div className="col-6">
		                <div className="row">
		                  <a href={twitchURL} style={{"text-decoration" : "none"}}>
			                <div className="row">
			                  <button className="btn btn-light-gray" >
			                  	Verify Without Email
			                  </button>
			                  </div>
			                </a>
		                  </div>	
		              </div>


		            </div>
		      


		     


		      <div className="row justify-content-left mb-4">
		              <div className="col-12">
		                <div className="store-fineprint text-start">By clicking "Verify & Provide Email" you agree to receive email updates from Stream Turret and Type 2 Labs</div>
		              </div>
		            </div>
		      

		     


      		</div>
	)

}


function WelcomeMessage(props) {

  console.log("nVotesAvailable",props.nVotesAvailable)

  return (<p className="store-subtitle-bold-purple mb-4">Welcome, {props.voterDisplayName}</p>)
}





